"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HSGT = void 0;
var react_1 = __importStar(require("react"));
var hsgt_1 = require("../../modules/quote/hsgt");
require("./index.less");
/** 沪深港通 */
function HSGT() {
    var _this = this;
    var _a = (0, react_1.useState)(null), showdata = _a[0], SetShowData = _a[1];
    /** 获取数据 */
    var gethgts = function () { return __awaiter(_this, void 0, void 0, function () {
        var back;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, hsgt_1.hsgt)()];
                case 1:
                    back = _a.sent();
                    if (back != null) {
                        SetShowData(back);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        gethgts();
        var cd = setInterval(function () {
            gethgts();
        }, 60 * 1000);
        return function () {
            try {
                clearInterval(cd);
            }
            catch (error) {
            }
        };
    }, []);
    return (react_1.default.createElement("div", { className: "quote_hsgt" },
        showdata != null &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("table", null,
                    react_1.default.createElement("tbody", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("a", { href: "./gridlist.html#sh_hk_board", className: "sg" }, "\u6CAA\u80A1\u901A(\u6E2F>\u6CAA)"),
                                react_1.default.createElement(HSGT_ED_ZJ, { data: showdata.hk2sh })),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("a", { href: "./gridlist.html#sz_hk_board", className: "sg" }, "\u6DF1\u80A1\u901A(\u6E2F>\u6DF1)"),
                                react_1.default.createElement(HSGT_ED_ZJ, { data: showdata.hk2sz })),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("a", { href: "./gridlist.html#hk_sh_stocks", className: "sg" }, "\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)"),
                                react_1.default.createElement(HSGTState, { status: showdata.sh2hk.status }),
                                react_1.default.createElement(HSGT_JME, { status: showdata.sh2hk.status, netBuyAmt: showdata.sh2hk.netBuyAmt })),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("a", { href: "./gridlist.html#hk_sz_stocks", className: "sg" }, "\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)"),
                                react_1.default.createElement(HSGTState, { status: showdata.sz2hk.status }),
                                react_1.default.createElement(HSGT_JME, { status: showdata.sz2hk.status, netBuyAmt: showdata.sz2hk.netBuyAmt })))))),
        showdata == null &&
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("table", null,
                    react_1.default.createElement("tbody", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("a", { href: "./gridlist.html#sh_hk_board", className: "sg" }, "\u6CAA\u80A1\u901A(\u6E2F>\u6CAA)"),
                                react_1.default.createElement(HSGTState, { status: 999 }),
                                react_1.default.createElement(HSGT_LR, { status: 999, money: '-' })),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("a", { href: "./gridlist.html#sz_hk_board", className: "sg" }, "\u6DF1\u80A1\u901A(\u6E2F>\u6DF1)"),
                                react_1.default.createElement(HSGTState, { status: 999 }),
                                react_1.default.createElement(HSGT_LR, { status: 999, money: '-' })),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("a", { href: "./gridlist.html#hk_sh_stocks", className: "sg" }, "\u6E2F\u80A1\u901A(\u6CAA>\u6E2F)"),
                                react_1.default.createElement(HSGTState, { status: 999 }),
                                react_1.default.createElement(HSGT_JME, { status: 1, netBuyAmt: 0 })),
                            react_1.default.createElement("td", null,
                                react_1.default.createElement("a", { href: "./gridlist.html#hk_sz_stocks", className: "sg" }, "\u6E2F\u80A1\u901A(\u6DF1>\u6E2F)"),
                                react_1.default.createElement(HSGTState, { status: 999 }),
                                react_1.default.createElement(HSGT_JME, { status: 1, netBuyAmt: 0 }))))))));
}
exports.HSGT = HSGT;
exports.default = HSGT;
/**
 * 沪深港通-状态
 * @param props
 * @returns
 */
function HSGTState(props) {
    if (props.status == 1) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "on" }),
            "\u6709\u989D\u5EA6"));
    }
    if (props.status == 2) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "off" }),
            "\u65E0\u989D\u5EA6"));
    }
    if (props.status == 3) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "off" }),
            "\u6536\u76D8"));
    }
    if (props.status == 4) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "off" }),
            "\u4F11\u5E02"));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, "-"));
}
/**
 * 沪股通额度资金显示
 * @param props
 * @returns
 */
function HSGT_ED_ZJ(props) {
    var data = props.data;
    // data.status = 4
    if (data.status == 4) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "off" }),
            "\u4F11\u5E02 ",
            react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html" }, "\u8D44\u91D1\u6D41\u5165 -"));
    }
    /** 盘后显示资金流 */
    else if (data.status == 3 && (data.dayAmtRemain > 0 || (data.dayAmtRemain == 0 && data.amtStatus == 3))) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "off" }),
            react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html" },
                "\u8D44\u91D1\u6D41\u5165 ",
                react_1.default.createElement(FormatMoney, { money: data.dayNetAmtIn })));
    }
    else if (data.amtStatus == 1 && (data.status == 1 || data.status == 3)) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(HSGTState, { status: data.status }),
            " \u5F53\u65E5\u989D\u5EA6\u5145\u8DB3");
    }
    else if (data.status == 2) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(HSGTState, { status: data.status }),
            " \u5F53\u65E5\u989D\u5EA6\u8017\u5C3D");
    }
    else if (data.status == 3 && data.buySellAmt && (data.buySellAmtDate && data.buySellAmtDate.toString() == data.date2.replace(/-/g, ''))) {
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "off" }),
            "\u6210\u4EA4\u603B\u989D ",
            react_1.default.createElement(FormatMoney, { money: data.buySellAmt }));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("b", { className: "off" }),
            react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html" },
                "\u8D44\u91D1\u6D41\u5165 ",
                react_1.default.createElement(FormatMoney, { money: data.dayNetAmtIn })));
    }
}
/**
 * 沪深港通数据格式化
 * @param money
 * @returns
 */
function FormatMoney(props) {
    var money = props.money;
    if (isNaN(money) || money === '') {
        return react_1.default.createElement(react_1.default.Fragment, null, money);
    }
    if (money == 0) {
        return react_1.default.createElement(react_1.default.Fragment, null, "-");
    }
    money = money * 10000;
    var hz = '';
    if (money >= 100000000 || money <= -100000000) {
        money = money / 100000000;
        hz = '亿';
    }
    else if (money >= 10000 || money <= -10000) {
        money = money / 10000;
        hz = '万';
    }
    var number_class = '';
    if (money > 0) {
        number_class = 'price_up';
    }
    else if (money < 0) {
        number_class = 'price_down';
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("span", { className: "nums ".concat(number_class) },
            money.toFixed(2),
            hz)));
}
/**
 * 沪深港通资金流入
 * @param props
 */
function HSGT_LR(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html", className: "zjlink" },
            "\u8D44\u91D1\u6D41\u5165",
            props.status == 4 ?
                react_1.default.createElement(react_1.default.Fragment, null, "-")
                :
                    react_1.default.createElement(FormatMoney, { money: props.money }))));
}
/**
 * 沪深港通净买额
 * @param props
 */
function HSGT_JME(props) {
    if (props.status == 4) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html", className: "zjlink" },
                "\u51C0\u4E70\u989D",
                ' ',
                "-")));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("a", { href: "//data.eastmoney.com/hsgt/index.html", className: "zjlink" },
            "\u51C0\u4E70\u989D",
            ' ',
            react_1.default.createElement(FormatMoney, { money: props.netBuyAmt }))));
}
